import React, { useState, useEffect } from "react";
import ssoManagementService from "../../../services/SSOManagementService";
import { SSOProviderDTO } from "@beable/roster-backend-client-v1";
import { emptySSOProvider } from "../../../test/fixtures";
import ProviderForm from "../Providers/ProviderForm";
import FormModal, { ModalMessageSettings, getResultMessage } from "../../Common/FormModal";

interface EditProviderModalProps {
  open: boolean;
  handleClose: any;
  providerItem: SSOProviderDTO;
}

export default function EditProviderModal(props: EditProviderModalProps) {
  const [messageSetting, setMessageSetting] = useState<ModalMessageSettings>();
  const [isLoading, setIsLoading] = useState(false);
  const [ssoProvider, setSSOProvider] = useState(props.providerItem);

  useEffect(() => {
    setSSOProvider({
      id: props.providerItem ? props.providerItem.id : emptySSOProvider.id,
      name: props.providerItem
        ? props.providerItem.name
        : emptySSOProvider.name,
      environment: props.providerItem
        ? props.providerItem.environment
        : emptySSOProvider.environment,
      customerIdentifier: props.providerItem
        ? props.providerItem.customerIdentifier
        : emptySSOProvider.customerIdentifier,
      userIdentifier: props.providerItem
        ? props.providerItem.userIdentifier
        : emptySSOProvider.userIdentifier,
      userIdentifierAccessor: props.providerItem
        ? props.providerItem.userIdentifierAccessor
        : emptySSOProvider.userIdentifierAccessor,
      redirectUrl: props.providerItem?.redirectUrl
        ? props.providerItem.redirectUrl
        : emptySSOProvider.redirectUrl,
    });
  }, [props]);

  const submitForm = async (ssoProvider: SSOProviderDTO, _allEnvs: boolean) => {
    setIsLoading(true);
    const result = await ssoManagementService.updateProvider(ssoProvider);

    const message = getResultMessage(
      result,
      `Provider edited successfully!`,
      `Failed to edit this provider!`
    );
    setMessageSetting(message);
    setIsLoading(false);
  };

  const handleClose = () => {
    props.handleClose(messageSetting?.severity === "success");
    setMessageSetting(undefined);
  }

  return (
    <FormModal
      isOpen={props.open}
      title={`Edit ${props.providerItem.name}`}
      description={`Edits the ${props.providerItem.name} provider for ${props.providerItem.environment}.`}
      isLoading={isLoading}
      handleClose={handleClose}
      message={messageSetting}
    >
      <ProviderForm
        onSubmit={submitForm}
        handleClose={handleClose}
        selectedItem={ssoProvider}
      />
    </FormModal>
  );
}
